import axios from "./axios";

class CategoryRepository {
  get(data) {
    return axios.get(`/categories`).then((response) => {
      return response.data;
    });
  }

  one(id) {
    return axios.get(`/categories/${id}`).then((response) => {
      return response.data;
    });
  }

  create(cat) {
    return axios.post(`/categories`, cat).then((response) => {
      return response.data;
    });
  }

  update(cat) {
    return axios.put(`/categories/${cat.id}`, cat).then((response) => {
      return response.data;
    });
  }

  save(cat) {
    if (!cat.id) return this.create(cat);
    else return this.update(cat);
  }
}

export default new CategoryRepository();



// WEBPACK FOOTER //
// ./src/data/category.repository.js